import { loader } from 'fetch-tree';
import { loadTerms, fetchTerm } from '../actions/terms';
import { allTerms as selectAllTerms, selectTerm } from '../selectors/terms';
import deprecated from '../deprecated';

export function termResource(options, id) {
    const { rootState } = options;

    return {
        id: `/term/${id}`,
        load() {
            return options.dispatch(fetchTerm(id));
        },
        find() {
            return selectTerm(rootState, id);
        },
    };
}

export const termLoader = loader({
    id: id => `term/${id}`,
    action: fetchTerm,
    selector: selectTerm,
});

export function termsResource(options) {
    return {
        id: 'all-terms',
        load() {
            return options.dispatch(loadTerms());
        },
        find() {
            return selectAllTerms(options.rootState);
        },
    };
}
export const allTerms = deprecated(termsResource, `use termsResource instead`);

export const allTermsLoader = loader({
    id: () => 'all-terms',
    action: loadTerms,
    selector: selectAllTerms,
});



// WEBPACK FOOTER //
// ./src/resources/terms.js